import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { IRestaurantLocalizationItem } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { ILocalizationContext, LocalizationContext } from '../../../../../../../localizationState/localizationContext';
import style from './LocalizationItem.module.scss';

interface ILocalizationItem {
	groupId: string;
	itemData: IRestaurantLocalizationItem;
	languageId: string;
}

const LocalizationItem: React.FC<ILocalizationItem> = ({ groupId, itemData, languageId }) => {
	const { setDeleteWordingData, changeTypeOfModalWindow } = useContext<ILocalizationContext>(LocalizationContext);

	const translationData = itemData.translations.find((el) => el.languageId === languageId);

	const isPersonalWording = itemData.level === 'Restaurant';

	const handleDeleteWording = () => {
		if (itemData.id) {
			setDeleteWordingData({
				groupId: groupId,
				wordingId: itemData.id,
			});
			changeTypeOfModalWindow('toConfirmDeleteItem');
		}
	};

	return (
		<div className={style.container}>
			<FullInfoField
				translationNameSpace="localizationSettings"
				label={itemData.label}
				value={translationData?.value}
			/>
			{/* {isPersonalWording && ( // TODO KMD-8157 (delete all logic later)
				<svg className={style.deleteIcon} onClick={handleDeleteWording}>
					<use xlinkHref={`${breadcrumbs}#crossMark`} />
				</svg>
			)} */}
		</div>
	);
};

export default LocalizationItem;
